import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useDeferredValue, useEffect, useTransition } from "react";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { NprogressStyle } from "./styles";
import { useAppStore } from "../../../store";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
NProgress.configure({
  showSpinner: false
});
var PanesTransition = function PanesTransition(_ref) {
  var children = _ref.children;
  var pathname = useAppStore(function (s) {
    return s.pathname;
  });
  var defPathname = useDeferredValue(pathname);
  var _useTransition = useTransition(),
    _useTransition2 = _slicedToArray(_useTransition, 2),
    startTransition = _useTransition2[1];
  var show = defPathname === pathname;
  useEffect(function () {
    if (show) {
      setTimeout(function () {
        startTransition(function () {
          NProgress.done();
        });
      }, 33);
    } else {
      NProgress.start();
    }
  }, [show]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NprogressStyle, {}), children]
  });
};
export default PanesTransition;